<template>
  <div>
    <v-container fluid id="content-form">
      <v-row>
        <v-col sm="4" md="3" lg="2" class="pa-0 d-none d-sm-block">
          <SideMenu />
        </v-col>
        <v-col cols="12" sm="8" md="9" lg="10" class="nav-right pa-8 pt-14 pl-sm-14">
          <v-stepper v-model="step">
            <v-stepper-header>
              <v-stepper-step :complete="step > 1" step="1">
                Revisar y validar datos
              </v-stepper-step>

              <v-divider />

              <v-stepper-step :complete="step > 2" step="2">
                Crear aviso para publicación
              </v-stepper-step>

              <v-divider />

              <v-stepper-step step="3">
                Enviar a moderación
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content class="pa-0" step="1">
                <OrganizationProfileForm stepper @forward-step="step = 2" />
              </v-stepper-content>

              <v-stepper-content class="pa-0" step="2">
                <OfferForm :offerObs="offerObs" @forward-step="step = 3" :titleForm="getTitle"/>
              </v-stepper-content>

              <v-stepper-content class="pa-0" step="3">
                <OfferModeration />
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
      </v-row>
    </v-container>

    <Footer />
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { userComputed } from "@/store/helpers.js";
import { handleTxt, meta } from "@/libs/mixins";
import OfferForm from "@/components/OfferForm";
import OrganizationProfileForm from "@/components/OrganizationProfileForm";
import SideMenu from "@/components/SideMenu";
import OfferModeration from "@/components/OfferModeration.vue";

export default {
    name: "OfferPost",
    
    components: {
        SideMenu,
        OfferForm,
        OfferModeration,
        OrganizationProfileForm,
    },

    props: ["offerObs"],

    mixins: [validationMixin, handleTxt, meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Nueva publicación",
        });
    }, 

    data() {
        return {
            step: 1,
        };
    },

    created() {
        // if (this.offerObs && typeof this.offerObs.experience !== "object") this.offerObs.experience = [ 0, 1 ];
        if (this.offerObs && this.offerObs.experience.length === 0) this.offerObs.experience = [0, 1];

        if (this.offerObs && this.offerObs.id) {
            this.offer = this.offerObs;
            this.offer.useAlias = this.offerObs.alias !== "" ? true : false;
            this.startDate = this.toSlashDate(this.offer.startAt);
            this.endDate = this.toSlashDate(this.offer.validity.end);
        }
    },

    computed: {
        ...userComputed,
        getTitle() {
            return `Nueva publicación de ${this.getUser.organization.name}`;
        }
    },
};
</script>
